import React, { useEffect, useMemo, useState } from "react";
import cookies from "browser-cookies";
import "./App.css";
import logo from "./hakai_logo.png";
import { CopyToClipboard } from "react-copy-to-clipboard";

function App() {
  const cookie = useMemo(() => cookies.get("authHeaders"), []);
  const [copied, setCopied] = useState(false);
  const [query, setQuery] = useState(null);

  // Format the cookies.authHeaders value to what is expected by the api client apps
  useEffect(() => {
    if (!cookie) {
      window.location.href = process.env.REACT_APP_LOGIN_URL;
    }

    const parseToken = async () => {
      // Validate the cookie
      const res = await fetch(
        `${process.env.REACT_APP_API_BASE}/auth/validate_token`,
        {
          credentials: "include",
        }
      );
      if (!res.ok) {
        window.location.href = process.env.REACT_APP_LOGIN_URL;
      }

      const { success } = await res.json();
      if (!success) {
        // Invalid, expired, whatever
        window.location.href = process.env.REACT_APP_LOGIN_URL;
      }

      let rawHeaders = JSON.parse(cookie);

      // Accommodate different possible cookies set by the API
      setQuery(
        new URLSearchParams({
          token_type: rawHeaders["token-type"] || "Bearer",
          access_token: rawHeaders["access-token"],
          expires_at: rawHeaders["expires-at"] || rawHeaders["expiry"],
        })
      );
    };
    // noinspection JSIgnoredPromiseFromCall
    parseToken();
  }, [cookie]);

  return (
    <div className="App">
      <div className="App-header">
        <img src={logo} className="App-logo" alt="hakai" />
        {query === null ? (
          <div className="loader">Loading...</div>
        ) : (
          <div className="page-content">
            Paste this text in the API client prompt
            <div>
              <CopyToClipboard
                text={query.toString()}
                onCopy={() => setCopied(true)}
              >
                <button className="button">
                  {copied ? (
                    <span>Copied!</span>
                  ) : (
                    <span>Click to Copy to Clipboard</span>
                  )}
                </button>
              </CopyToClipboard>
            </div>
            <div className="code-block">
              <code>{query.toString()}</code>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default App;
